import { forwardRef, useState, useImperativeHandle, useRef } from "react";
import { MultiSelect } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";

export const RolloverClientsMultiselect = forwardRef(
  ({ id, name, label, dataSource, fields, change, ...rest }, ref) => {
    const { i18n } = useTranslation();
    const componentRef = useRef(null);
    const [isReadonly, setIsReadonly] = useState(false);

    useImperativeHandle(ref, () => ({
      getComponentRef: () => componentRef.current,
      setIsReadonly: (value) => setIsReadonly(value),
    }));

    return (
      <div>
        {!isReadonly && (
          <MultiSelect
            ref={componentRef}
            id={id}
            name={name}
            label={label}
            dataSource={dataSource}
            fields={fields}
            locale={i18n?.language}
            change={change}
            sortOrder="Ascending"
            disabled={isReadonly}
            allowObjectBinding
            htmlFor={id}
            {...rest}
          />
        )}
      </div>
    );
  }
);
